const LoadingPage = () => {
	return (
		<div className="w-100 h-100 d-flex justify-content-center align-items-center fs-5 fw-bold text-white">
			Loading...
		</div>
	);
};

export default LoadingPage;
